"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getElementByHook(element, hook) {
    return element.querySelector("[data-hook=\"" + hook + "\"]");
}
exports.default = getElementByHook;
//# sourceMappingURL=getElementByHook.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/playable/dist/src/modules/ui/core/getElementByHook.js
// module id = 7
// module chunks = 0